import { isObjectEmpty } from '@services/validation/validation';

export interface BillingDataPayload {
    clientId: string;
    email: string;
    companyName: string;
    billingEmail: string;
    country: string;
    city: string;
    address: string;
    address2: string;
    postalCode: string;
    poNumber?: string;
    businessTaxType: string;
    businessTaxId: string;
}

export function instanceOfBillingData (obj: any): obj is BillingDataPayload {
    return !isObjectEmpty(obj)
        && 'clientId' in obj
        && 'email' in obj
        && 'companyName' in obj
        && 'billingEmail' in obj
        && 'country' in obj
        && 'city' in obj
        && 'address' in obj
        && 'postalCode' in obj
        && 'businessTaxType' in obj
        && 'businessTaxId' in obj;
}
